<template>
  <view-wrapper>
    <div class="flex flex-col justify-around flex-grow w-full px-5 pt-10 item-center sm:flex-row">
      <!-- images -->
      <div class="flex items-start justify-center sm:w-1/2">
        <div
          v-if="item.images"
          class="flex flex-col items-center max-w-sm mb-5"
        >
          <p v-if="item.name" class="flex w-full max-w-sm text-4xl text-left sm:hidden">{{ item.name }}</p>
          <!-- large image -->
          <div class="flex flex-col items-center justify-center h-64 px-3">
            <div class="flex justify-center flex-shrink max-h-64">
              <img
                v-for="(img, index) in item.images" :key="index + 'item_pics-large'"
                v-show="imgNum === index"
                :src="`https://d1y8zsubnbo9se.cloudfront.net/pictures/${img.id}.${img.extension}`"
                class="object-scale-down my-2 select-none w-90"
              />
            </div>
          </div>
          <!-- Small images -->
          <div class="flex flex-row flex-wrap items-center w-full">
            <div
              v-for="(img, index) in item.images" :key="index + 'item_pics-small'"
              class="flex justify-start w-10 h-10 p-1"
            >
              <img
                @click="imgNum = index"
                @mouseenter="imgNum = index"
                :src="`https://d1y8zsubnbo9se.cloudfront.net/pictures/${img.id}.${img.extension}`"
                class="object-scale-down shadow-xs cursor-pointer select-none"
                :class="{'border-2 rounded-sm border-blue-500': imgNum === index}"
              />
            </div>
          </div>

        </div>
      </div>
      <!-- Text -->
      <div class="flex items-start justify-center px-4 sm:w-1/2">
        <div class="flex flex-col items-start justify-center w-full max-w-sm">
          <p v-if="item.name" class="hidden text-4xl sm:flex">{{ item.name }}</p>
          <p v-if="item.subCategory" class="text-xl text-gray-600">
            {{ item.subCategory }}
          </p>
          <p v-if="item.category" class="text-sm text-gray-600">
            {{ item.category }}
          </p>
          <div v-if="item.description" class="pt-6 pb-10">
            <p
              v-for="paragraph in item.description.split('\n')" :key="paragraph"
              class="pb-3"
            >
              {{paragraph}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </view-wrapper>
</template>

<script>
import { getItemSlim } from '@/api/item';
import ViewWrapper from '../components/ViewWrapper.vue';

export default {
  name: 'item',
  components: {
    ViewWrapper,
  },
  data() {
    return {
      item: {},
      imgNum: 0,
    };
  },
  methods: {
  },
  mounted() {
    getItemSlim(this.$route.params.item_id)
      .then((item) => {
        this.item = item;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>
